/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: sYX9BWa2o65b

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { RawThead } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawTable/Thead"; // plasmic-import: IgD9Hsr1VwfO/codeComponent
import TableTr from "../../TableTr"; // plasmic-import: ClRepu2PwVaX/component
import TableTh from "../../TableTh"; // plasmic-import: RjYJ6AJe84Rc/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicTableThead.module.css"; // plasmic-import: sYX9BWa2o65b/css

createPlasmicElementProxy;

export type PlasmicTableThead__VariantMembers = {};
export type PlasmicTableThead__VariantsArgs = {};
type VariantPropType = keyof PlasmicTableThead__VariantsArgs;
export const PlasmicTableThead__VariantProps = new Array<VariantPropType>();

export type PlasmicTableThead__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicTableThead__ArgsType;
export const PlasmicTableThead__ArgProps = new Array<ArgPropType>("children");

export type PlasmicTableThead__OverridesType = {
  root?: Flex__<typeof RawThead>;
};

export interface DefaultTableTheadProps {
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicTableThead__RenderFunc(props: {
  variants: PlasmicTableThead__VariantsArgs;
  args: PlasmicTableThead__ArgsType;
  overrides: PlasmicTableThead__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <RawThead
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "__wab_instance",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <TableTr className={classNames("__wab_instance", sty.tableTr__ni9TZ)}>
            <TableTh
              className={classNames("__wab_instance", sty.tableTh__f7Joj)}
            />

            <TableTh
              className={classNames("__wab_instance", sty.tableTh__cg9Dj)}
            />

            <TableTh
              className={classNames("__wab_instance", sty.tableTh__v3Lz)}
            />

            <TableTh
              className={classNames("__wab_instance", sty.tableTh___1C0Ga)}
            />
          </TableTr>
        ),
        value: args.children
      })}
    </RawThead>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: typeof RawThead;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTableThead__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTableThead__VariantsArgs;
    args?: PlasmicTableThead__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicTableThead__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicTableThead__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTableThead__ArgProps,
          internalVariantPropNames: PlasmicTableThead__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTableThead__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTableThead";
  } else {
    func.displayName = `PlasmicTableThead.${nodeName}`;
  }
  return func;
}

export const PlasmicTableThead = Object.assign(
  // Top-level PlasmicTableThead renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicTableThead
    internalVariantProps: PlasmicTableThead__VariantProps,
    internalArgProps: PlasmicTableThead__ArgProps
  }
);

export default PlasmicTableThead;
/* prettier-ignore-end */
